module.exports = __webpack_public_path__ + "media/images/emblems/Wetzikon-blazon-37cd6c8aa7d2d66f489275cbf10a8df9.svg";